import React from "react";

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
 as?: "p" | "span" | "div" | "label";
 size?: "xs" | "sm" | "md" | "lg" | "xl";
 weight?: "normal" | "medium" | "semibold";
 color?: "default" | "muted" | "primary" | "error" | "success";
 align?: "left" | "center" | "right";
}

const sizeClasses = {
 xs: "text-xs",
 sm: "text-sm",
 md: "text-base",
 lg: "text-lg",
 xl: "text-xl",
};

const weightClasses = {
 normal: "font-normal",
 medium: "font-medium",
 semibold: "font-semibold",
 bold: "font-bold",
};

const colorClasses = {
 default: "text-gray-900",
 muted: "text-gray-600",
 primary: "text-blue-600",
 error: "text-red-600",
 success: "text-green-600",
};

const alignClasses = {
 left: "text-left",
 center: "text-center",
 right: "text-right",
};

export const Text: React.FC<TextProps> = ({
 as: Component = "p",
 size = "md" as "xs" | "sm" | "md" | "lg" | "xl",
 weight = "normal" as "normal" | "medium" | "semibold" | "bold",
 color = "default",
 align = "left",
 className = "",
 children,
 ...props
}) => {
 return (
  <Component
   className={`${sizeClasses[size]} ${weightClasses[weight]} ${colorClasses[color]} ${alignClasses[align]} ${className}`}
   {...props}
  >
   {children}
  </Component>
 );
};

export default Text;

